require('./brokerOrdersAndMovementsActivityDetails.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const moment = require('moment');
// @ commons
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const OKTableRowDetails = require('components/rebrand/OKTableRowDetails/OKTableRowDetails');
const OKTableRowDetailsItem = require('components/rebrand/OKTableRowDetails/OKTableRowDetailsItem/OKTableRowDetailsItem');
const BrokerExecutionTable = require('components/broker/commons/brokerExecutionTable/brokerExecutionTable');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKButton } = require('components/commons/OKButton/OKButton');
// @ core
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
// @ constants
const {
    BROKER_ANY_MARKET,
    DATE_FORMAT_ES,
    HYPHEN,
    BROKER_INTERNAL_SUSCRIPTION_CODE,
    BROKER_EXTERNAL_SUSCRIPTION_CODE,
    BROKER_ORDERS_AND_MOVEMENTS_PLAN_PERIODIC,
    BROKER_ORDERS_AND_MOVEMENTS_PLAN_PENDING_MOVES,
    BROKER_ORDER_TYPE_LIMITED_DESCRIPTION,
    BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_NULLED,
    BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_PENDING,
    BROKER_ORDERS_AND_MOVEMENTS_PLAN_CONTRIBUTION_NO_NEXT_DATE,
    BROKER_JOINT_CONTRACTS_FUND,
    BROKER_JOINT_CONTRACTS_VALUE,
    EURO_SYMBOL,
    PERCENTAGE_SYMBOL,
    BROKER_TYPE_STOCKS_NEW_DECIMALS
} = require('constants/index');
const language = getLanguage();
// @ helpers
const DateHelper = require('utilities/dateHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { formatAmount, formatCurrency, parseSpanishNumberToFloat, formatWithoutRound } = require('utilities/currencyHelper');
const { toFirstUppercase } = require('utilities/stringHelper');
// @ actions
const { getActivityDetails } = require('actions/brokerContractActivities');
// @ components
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');

class BrokerOrdersAndMovementsActivityDetails extends React.Component {
    constructor(props) {
        super(props);

        this.buildError = this.buildError.bind(this);
        this.handleRetry = this.handleRetry.bind(this);
        this.handleCancelPlanPendingMovement = this.handleCancelPlanPendingMovement.bind(this);
    }

    componentDidMount() {
        const { immTransaction, getActivityDetails } = this.props;
        getActivityDetails(immTransaction);
    }

    getNumberOfColumns(immTransaction) {
        switch (immTransaction.get('movementType')) {
            case BROKER_JOINT_CONTRACTS_FUND:
                return 6;
            case BROKER_ORDERS_AND_MOVEMENTS_PLAN_PERIODIC:
                return 8;
            case BROKER_ORDERS_AND_MOVEMENTS_PLAN_PENDING_MOVES:
                return 3;
            case BROKER_JOINT_CONTRACTS_VALUE:
            default:
                return 7;
        }
    }

    buildDetailsBlock(id, immTransaction) {
        switch (immTransaction.get('movementType')) {
            case BROKER_JOINT_CONTRACTS_VALUE:
                return this.buildValueDetailsBlock(id, immTransaction);
            case BROKER_JOINT_CONTRACTS_FUND:
                return this.buildFundDetailsBlock(id, immTransaction);
            case BROKER_ORDERS_AND_MOVEMENTS_PLAN_PERIODIC:
                return this.buildPlanDetailsBlock(id, immTransaction);
            case BROKER_ORDERS_AND_MOVEMENTS_PLAN_PENDING_MOVES:
                return this.buildPlanPendingMoves(id, immTransaction);
            default:
                return '';
        }
    }

    handleCancelPlanPendingMovement(detailsIndex) {
        const { history, immTransaction } = this.props;
        const contractNumber = immTransaction.get('contractNumber');
        const movementId = immTransaction.get('id');

        history.push(`/myprofile/broker/cancel-pension-plan-pending-order/${contractNumber}/${movementId}/${detailsIndex}`);
    }

    buildError() {
        const { immTransaction } = this.props;
        const errorMessage = formatText('broker-ordersAndMovementsActivityDetailsErrorMessage');
        const numberOfColumns = this.getNumberOfColumns(immTransaction);
        const retryButton = (
            <OKButton
                id="btn_brokerOrdersAndMovementsActivityDetails_errorMessage_retry"
                onClick={this.handleRetry}
            >
                <FormattedText value="broker-ordersAndMovementsRetry" />
            </OKButton>
        );

        return (
            <OKTableRow id={this.props.id}>
                <OKTableCell
                    className="broker-orders-and-movements-activity-details__error-message"
                    colSpan={numberOfColumns}
                >
                    <EmptyState primaryText={errorMessage} button={retryButton} iconType="nointernet-wealth"/>
                </OKTableCell>
            </OKTableRow>
        );
    }

    buildFundDetailsBlock(id, immTransaction) {
        const { immOrdersAndMovements } = this.props;
        const immDetails = immTransaction.getIn(['details', 'data']);
        const operationCode = immTransaction.get('operationCode');
        const operationKey = `fundsOrdersandMovementsOperationCode-${operationCode}`;
        const operationText = formatText(operationKey);
        const operationType = operationText !== '####' ? operationText : '-';
        const operationDate = DateHelper.buildFormattedDate(immDetails.get('operationDate'), DATE_FORMAT_ES);
        const valueDate = DateHelper.buildFormattedDate(immTransaction.get('dateValue'), DATE_FORMAT_ES);
        let shares = HYPHEN;
        if (immTransaction.get('shares') !== HYPHEN && immTransaction.get('shares')) {
            shares = formatWithoutRound(parseSpanishNumberToFloat(immTransaction.get('shares')), 5);
        }
        const liquidativeValue = immTransaction.get('liquidativeValue');
        const currency = liquidativeValue.get('currency');
        const liquidativeValueElement = liquidativeValue.get('amount') === HYPHEN ?
            HYPHEN :
            `${formatAmount(liquidativeValue.get('amount'), undefined, 3)} ${formatCurrency(liquidativeValue.get('currency'))}`;
        const holdbackAmount = immDetails.getIn(['holdbacks', 'import', 'amount']);
        const operationCodeDetails = [ BROKER_INTERNAL_SUSCRIPTION_CODE, BROKER_EXTERNAL_SUSCRIPTION_CODE ]
        const associatedAccount = immDetails.get("associatedAccount") ? (
            <OKTableRowDetailsItem
                title={formatText(
                    "broker-ordersAndMovementsActivityDetailsAccountNr"
                )}
                value={immDetails.get("associatedAccount")}
            />
        ) : null;
        let holdbackText = HYPHEN;
        let holdBacks = null;

        const selectedOption = immOrdersAndMovements.getIn(['selectedOption', 'value']);
        let detailsTitle;
        let operationDateTitle;
        let liquidativeValueElementTitle;
        let valueDateTitle;

        let commissions = null;
        const charge = immDetails.get("charge");
        const chargeText = charge === "0,00" ? HYPHEN : `${charge} ${formatCurrency(currency)}`;

        let liquidativeValueTag = null;

        if (selectedOption === BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_PENDING) {
            detailsTitle = "broker-ordersAndMovementsActivityDetailsTitlePending";
            operationDateTitle = formatText('broker-ordersAndMovementsActivityDetailsOperationDatePending');
            valueDateTitle = formatText('broker-ordersAndMovementsActivityDetailsValueDatePending');
        }
        else if (selectedOption === BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_NULLED) {
            detailsTitle = "broker-ordersAndMovementsActivityDetailsTitleNulled";
            operationDateTitle = formatText('broker-ordersAndMovementsActivityDetailsOperationDateNulled');
            valueDateTitle = formatText('broker-ordersAndMovementsActivityDetailsValueDateNulled');
        }
        else {
            commissions = (
                <OKTableRowDetailsItem
                    title={formatText(
                        "broker-ordersAndMovementsActivityDetailsCharges"
                    )}
                    value={chargeText}
                />
            );
            liquidativeValueElementTitle = formatText('broker-ordersAndMovementsContractInformationLiquidativeValueConsolidated');
            liquidativeValueTag = (
                <OKTableRowDetailsItem
                    title={liquidativeValueElementTitle}
                    value={liquidativeValueElement}
                />
            );
            detailsTitle = "broker-ordersAndMovementsActivityDetailsTitleConsolidated";
            operationDateTitle = formatText('broker-ordersAndMovementsActivityDetailsOperationDateConsolidated');
            valueDateTitle = formatText('broker-ordersAndMovementsActivityDetailsValueDateConsolidated');

            if (holdbackAmount !== undefined) {
            holdbackText = `${formatAmount(holdbackAmount)} ${formatCurrency(currency)} (${immDetails.getIn(['holdbacks', 'percentage'])} ${PERCENTAGE_SYMBOL})`;
            holdBacks = (
                <OKTableRowDetailsItem
                    title={formatText("broker-ordersAndMovementsActivityDetailsHoldbacks")}
                    value={holdbackText}
                />
            );
        }
        }

        return (
            <OKTableRowDetails title={detailsTitle}>
                <h4>
                    <FormattedText value="broker-ordersAndMovementsActivityDetailsMovementData" />
                </h4>
                <OKTableRowDetailsItem
                    title={operationDateTitle}
                    value={operationDate}
                />
                <OKTableRowDetailsItem
                    title={formatText("broker-ordersAndMovementsActivityDetailsOperationType")}
                    value={operationType}
                />
                <OKTableRowDetailsItem
                    title={formatText("broker-ordersAndMovementsContractInformationShares")}
                    value={shares}
                />
                {liquidativeValueTag}
                <OKTableRowDetailsItem
                    title={valueDateTitle}
                    value={valueDate}
                />
                {associatedAccount}
                <OKTableRowDetailsItem
                    title={formatText("broker-ordersAndMovementsActivityDetailsSituation")}
                    value={immTransaction.get("stateLabel")}
                />
                {holdBacks}
                {commissions}
                {operationCodeDetails.includes(operationCode) ? (
                    <React.Fragment>
                        <h4>
                            <FormattedText value="broker-ordersAndMovementsActivityDetailsTransferData" />
                        </h4>
                        <OKTableRowDetailsItem
                            title={formatText("broker-ordersAndMovementsActivityDetailsReferenceNr")}
                            value={immDetails.get("referenceNumber")}
                        />
                        <OKTableRowDetailsItem
                            title={formatText("broker-ordersAndMovementsActivityDetailsOriginManager")}
                            value={immDetails.get("originManager")}
                        />
                        <OKTableRowDetailsItem
                            title={formatText("broker-ordersAndMovementsActivityDetailsDestinataryManager")}
                            value={immDetails.get("destinataryManager")}
                        />
                        <OKTableRowDetailsItem
                            title={formatText("broker-ordersAndMovementsActivityDetailsDestAccountNr")}
                            value={immDetails.get("destinataryAccount")}
                        />
                    </React.Fragment>
                ) : (
                    ""
                )}
            </OKTableRowDetails>
        );
    }

    buildPlanDetailsBlock(id, immTransaction) {
        const immDetails = immTransaction.getIn(['details', 'data']);
        //const dateNext = DateHelper.buildFormattedDate(immTransaction.get('dateNext'), DATE_FORMAT_ES);
        const dateRevaluate = (immDetails.get('withRevaluation') && DateHelper.buildFormattedDate(immDetails.get('dateRevaluate'), DATE_FORMAT_ES)) || HYPHEN;
        const plainAmountObject = getPlainAmountObject(immTransaction.get('import'));
        const importElem = (
            <OneLineSymbolAmount
                amountObject={plainAmountObject}
                language={language}
                amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
        );
        const periodicity = toFirstUppercase(immTransaction.get('periodicityText'));
        let currentRevaluation;

        if (immDetails.get('withRevaluation')) {
            switch (immDetails.get('typeRevaluation')) {
                case 'F':
                    currentRevaluation = formatText(
                        'broker-ordersAndMovementsActivityDetailsRevaluationPercentage',
                        [immDetails.get('qttyRevaluation')]
                    );
                    break;
                case 'P':
                    currentRevaluation = formatText(
                        'broker-ordersAndMovementsActivityDetailsRevaluationAll'
                    );
                    break;
                case 'I':
                    currentRevaluation = formatText(
                        'broker-ordersAndMovementsActivityDetailsRevaluationByImport',
                        [immDetails.get('qttyRevaluation')]
                    );
                    break;
            }
        } else {
            currentRevaluation = formatText(
                'broker-ordersAndMovementsActivityDetailsWithoutRevaluation'
            );
        }

        let dateNext =  HYPHEN;
        if (immTransaction.get('dateNext') !== BROKER_ORDERS_AND_MOVEMENTS_PLAN_CONTRIBUTION_NO_NEXT_DATE) {
            dateNext = DateHelper.buildFormattedDate(immTransaction.get('dateNext'), DATE_FORMAT_ES);
        }

        return (
            <OKTableRowDetails title="broker-ordersAndMovementsActivityDetailsTitle">
                <OKTableRowDetailsItem
                    title={formatText('broker-ordersAndMovementsActivityDetailsPeriodicity')}
                    value={periodicity}
                />
                <OKTableRowDetailsItem
                    title={formatText('broker-ordersAndMovementsActivityDetailsImportAlone')}
                    value={importElem}
                />
                <OKTableRowDetailsItem
                    title={formatText('broker-ordersAndMovementsActivityDetailsDateNext')}
                    value={dateNext}
                />
                <OKTableRowDetailsItem
                    title={formatText('broker-ordersAndMovementsActivityDetailsSituation')}
                    value={immTransaction.get('state')}
                />
                <OKTableRowDetailsItem
                    title={formatText('broker-ordersAndMovementsActivityDetailsAnualRevaluation')}
                    value={currentRevaluation}
                />
                <OKTableRowDetailsItem
                    title={formatText('broker-ordersAndMovementsActivityDetailsNextRevaluation')}
                    value={dateRevaluate}
                />
            </OKTableRowDetails>
        );
    }

    buildPlanPendingMoves(id, immTransaction) {
        const immDetails = immTransaction.getIn(['details', 'data', 'listaMovPendientesDet', 'movPendienteDet']) || [];

        const detailRows = immDetails.map((immDetail, index) => {
            const amountObject = {
                amount: immDetail.getIn(['importe', 'importe']),
                currency: immDetail.getIn(['importe', 'divisa'])
            };
            const formattedDate = moment(immDetail.getIn(['fecValorLiq'])).format(DATE_FORMAT_ES);
            const cancellable = __CONTACT_CENTER__ && immDetail.get('cancellable');

            const cancelButtonColumn = cancellable ? (
                <td className="broker-execution-table__cell broker-orders-and-movements-activity-details__cancel-button-column">
                    <OKButton
                        modifier="tasks-light"
                        size="small"
                        customLinkClassName="broker-orders-and-movements-activity-details__cancel-button"
                        onClick={() => this.handleCancelPlanPendingMovement(index)}>
                        <i className="icon icon-eliminar broker-orders-and-movements-activity-details__cancel-icon" />
                    </OKButton>
                </td>
            ) : null;
            const plainAmountObject = getPlainAmountObject(amountObject);

            return (
                <tr key={index}>
                    <td className="broker-execution-table__cell">
                        {formattedDate}
                    </td>
                    <td className="broker-execution-table__cell">
                        <OneLineSymbolAmount
                            amountObject={plainAmountObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                    </td>
                    {cancelButtonColumn}
                </tr>
            );
        });

        return (
            <OKTableRowDetails title="broker-ordersAndMovementsActivityDetailsTitle">
                <article className="broker-orders-and-movements-activity-details__plan-pending-moves">
                    <header className="broker-orders-and-movements-activity-details__plan-pending-moves__title">
                        <FormattedText value="broker-executionTableTitle" />
                    </header>
                    <div className="broker-orders-and-movements-activity-details__plan-pending-moves__separator" />
                    <section className="broker-orders-and-movements-activity-details__plan-pending-moves__body">
                        <table className="broker-orders-and-movements-activity-details__plan-pending-moves__table">
                            <thead>
                                <tr>
                                    <th className="broker-orders-and-movements-activity-details__plan-pending-moves__cell-header">
                                        <FormattedText
                                            value="broker-ordersAndMovementsPlanPendingMovesSettlementDate"
                                            format="uppercase"
                                        />
                                    </th>
                                    <th className="broker-orders-and-movements-activity-details__plan-pending-moves__cell-header">
                                        <FormattedText
                                            value="broker-ordersAndMovementsPlanPendingMovesAmount"
                                            format="uppercase"
                                        />
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {detailRows}
                            </tbody>
                        </table>
                    </section>
                </article>
            </OKTableRowDetails>
        );
    }

    buildValueDetailsBlock(id, immTransaction) {
        const immDetails = immTransaction.getIn(['details', 'data']);
        const orderType = immDetails.get('orderType');
        const immExecutionDetails = immDetails.get('executionDetails');
        const readableDate = DateHelper.buildFormattedDate(immDetails.get('date'), DATE_FORMAT_ES);
        const deadline = DateHelper.buildFormattedDate(immDetails.get('dateLimit'), DATE_FORMAT_ES);
        const hour = immDetails.get('hour');
        const dateHour = `${readableDate} ${HYPHEN} ${hour}`;
        const titles = '' + immDetails.get('titles');
        const market = immDetails.get('market') === BROKER_ANY_MARKET ?
            'broker-ordersAndMovementsActivityDetailsContinousMarket' :
            immDetails.get('market');

        let limitedAmountElement;
        if (orderType === BROKER_ORDER_TYPE_LIMITED_DESCRIPTION) {
            const limitedAmountObject = {
                amount: immDetails.getIn(['limitedAmount', 'amount']),
                currency: immDetails.getIn(['limitedAmount', 'currency']),
                decimalsLength: BROKER_TYPE_STOCKS_NEW_DECIMALS
            };
            const plainAmountObject = getPlainAmountObject(limitedAmountObject);
            const limitedAmount = limitedAmountObject.amount === HYPHEN
                ? HYPHEN
                : (
                    <OneLineSymbolAmount
                        amountObject={plainAmountObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                );
            limitedAmountElement = (
                <OKTableRowDetailsItem
                    title={formatText('broker-ordersAndMovementsActivityDetailsLimitedAmount')}
                    value={limitedAmount}
                />
            );
        }

        let executionTable;
        const showTaxAmount = immExecutionDetails.find(elem => elem.get('taxAmount') !== null);

        if (immExecutionDetails && immExecutionDetails.count()) {
            executionTable = <BrokerExecutionTable immExecutionDetails={immExecutionDetails} showTaxAmount={showTaxAmount}/>;
        }

        let conditionValues;
        if (immDetails.get('condition')) {
            const valueName = immDetails.get('valueName');
            const conditionValue = immDetails.get('conditionValue');
            const percentageValue = `${conditionValue} ${PERCENTAGE_SYMBOL}`;
            const euroValue = `${formatAmount(conditionValue, undefined, 3)} ${EURO_SYMBOL}`;
            const condition = immDetails.get('condition').replace('(EURO)', euroValue)
                .replace('(%)', percentageValue);
            conditionValues = (
                <div>
                    <OKTableRowDetailsItem
                        title={formatText('broker-ordersAndMovementsActivityDetailsConditionValue')}
                        value={valueName}
                    />
                    <OKTableRowDetailsItem
                        title={formatText('broker-ordersAndMovementsActivityDetailsCondition')}
                        value={condition}
                    />
                </div>
            );
        }

        return (
            <section>
                <OKTableRowDetails title="broker-ordersAndMovementsActivityDetailsTitle">
                    <OKTableRowDetailsItem
                        title={formatText('broker-ordersAndMovementsActivityDetailsOrderNumber')}
                        value={immDetails.get('orderNumber')}
                    />
                    <OKTableRowDetailsItem
                        title={formatText('broker-ordersAndMovementsActivityDetailsOrderType')}
                        value={formatText(`broker-orderType.${(orderType).trim().toLowerCase()}`)}
                    />
                    <OKTableRowDetailsItem
                        title={formatText('broker-ordersAndMovementsActivityDetailsMarket')}
                        value={market}
                    />
                    <OKTableRowDetailsItem
                        title={formatText('broker-ordersAndMovementsActivityDetailsValue')}
                        value={immTransaction.get('description')}
                    />
                    <OKTableRowDetailsItem
                        title={formatText('broker-ordersAndMovementsActivityDetailsOperationType')}
                        value={immTransaction.get('type')}
                    />
                    {conditionValues}
                    <OKTableRowDetailsItem
                        title={formatText('broker-ordersAndMovementsActivityDetailsDate')}
                        value={dateHour}
                    />
                    <OKTableRowDetailsItem
                        title={formatText('broker-ordersAndMovementsActivityDeadline')}
                        value={deadline}
                    />
                    <OKTableRowDetailsItem
                        title={formatText('broker-ordersAndMovementsActivityDetailsState')}
                        value={immTransaction.get('state')}
                    />
                    <OKTableRowDetailsItem
                        title={formatText('broker-ordersAndMovementsActivityDetailsTitles')}
                        value={titles}
                    />
                    {limitedAmountElement}
                </OKTableRowDetails>
                {executionTable}
            </section>
        );
    }

    handleRetry() {
        const { immTransaction, getActivityDetails } = this.props;
        getActivityDetails(immTransaction);
    }

    render() {
        const { id, immTransaction } = this.props;
        const numberOfColumns = this.getNumberOfColumns(immTransaction);
        let content;

        if (immTransaction.getIn(['details', 'success'])) {
            const innerContent = this.buildDetailsBlock(id, immTransaction);
            let tablePadding;

            if (immTransaction.get('movementType') === BROKER_ORDERS_AND_MOVEMENTS_PLAN_PENDING_MOVES) {
                tablePadding = 1;
            } else {
                tablePadding = 2;
            }

            const numberOfColumnsRight = numberOfColumns - tablePadding;

            content = (
                <OKTableRow id={id}>
                    <OKTableCell colSpan={tablePadding} />
                    <OKTableCell colSpan={numberOfColumnsRight}>
                        {innerContent}
                    </OKTableCell>
                </OKTableRow>
            );
        } else if (immTransaction.getIn(['details', 'error'])) {
            content = this.buildError();
        } else {
            content = (
                <OKTableRow id={id}>
                    <OKTableCell colSpan={numberOfColumns}>
                        <LoadingSection />
                    </OKTableCell>
                </OKTableRow>
            );
        }

        return content;
    }
}

BrokerOrdersAndMovementsActivityDetails.propTypes = {
    history: PropTypes.object.isRequired,
    immMyInvestments: PropTypes.object.isRequired,
    immOrdersAndMovements: PropTypes.object.isRequired,
    immTransaction: PropTypes.object,
    id: PropTypes.string,
    getActivityDetails: PropTypes.func
};

module.exports = connect(
    state => ({
        immMyInvestments: state.brokerMyInvestments,
        immOrdersAndMovements: state.brokerOrdersAndMovements,
    }),
    {
        getActivityDetails
    }
)(withRouter(BrokerOrdersAndMovementsActivityDetails));
